// extracted by mini-css-extract-plugin
export default {"mapWrapper":"styles_mapWrapper__DvhW0","mapInfoBox":"styles_mapInfoBox__ED7XA"};